import React from 'react';
import { motion } from 'framer-motion';
import { VIEWPORT, revealGroup, revealItem } from '../../lib/motion';

// Un groupe (en-tête de section, grille de cartes) dont les enfants <RevealItem> apparaissent
// en cascade, une seule fois, quand le groupe entre dans l'écran.
export function RevealGroup({ as = 'div', delay = 0, children, ...rest }) {
  const Comp = motion[as] || motion.div;
  const variants = delay
    ? { hidden: {}, show: { transition: { ...revealGroup.show.transition, delayChildren: delay } } }
    : revealGroup;
  return (
    <Comp variants={variants} initial="hidden" whileInView="show" viewport={VIEWPORT} {...rest}>
      {children}
    </Comp>
  );
}

// Un enfant d'un RevealGroup : monte de 24 px en s'opacifiant.
export function RevealItem({ as = 'div', children, ...rest }) {
  const Comp = motion[as] || motion.div;
  return (
    <Comp variants={revealItem} {...rest}>
      {children}
    </Comp>
  );
}
